/* Matches the options for the "domain" field of a Legal Page created in Contentful */
const DOMAIN_OPTIONS = {
  AGENCY: 'withagency.com',
  AGENCY_ADSAFE: 'withagency.co',
};

// common js exports are used we can use this file in gatsby-node.js
module.exports = DOMAIN_OPTIONS;
